import { render } from "./MaxHeight.vue?vue&type=template&id=45b07354&scoped=true&ts=true"
import script from "./MaxHeight.vue?vue&type=script&lang=ts"
export * from "./MaxHeight.vue?vue&type=script&lang=ts"

import "./MaxHeight.vue?vue&type=style&index=0&id=45b07354&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b07354"]])

export default __exports__